/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_AfInputs */

const en_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const es_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const de_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const zh_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const ar_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const fr_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const vi_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const sw_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const th_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const bs_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const ja_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const ko_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const pt_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const it_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const sv_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const nl_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const da_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const nb_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const fi_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const pl_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const ru_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const tr_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const hi_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const id_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const ms_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const cs_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const el_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const he_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const af_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

const hu_nav_language_af = /** @type {(inputs: Nav_Language_AfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikaans`)
};

/**
* | output |
* | --- |
* | "Afrikaans" |
*
* @param {Nav_Language_AfInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_af = /** @type {((inputs?: Nav_Language_AfInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_AfInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_af(inputs)
	if (locale === "de") return de_nav_language_af(inputs)
	if (locale === "zh") return zh_nav_language_af(inputs)
	if (locale === "ar") return ar_nav_language_af(inputs)
	if (locale === "fr") return fr_nav_language_af(inputs)
	if (locale === "vi") return vi_nav_language_af(inputs)
	if (locale === "sw") return sw_nav_language_af(inputs)
	if (locale === "th") return th_nav_language_af(inputs)
	if (locale === "bs") return bs_nav_language_af(inputs)
	if (locale === "ja") return ja_nav_language_af(inputs)
	if (locale === "ko") return ko_nav_language_af(inputs)
	if (locale === "pt") return pt_nav_language_af(inputs)
	if (locale === "it") return it_nav_language_af(inputs)
	if (locale === "sv") return sv_nav_language_af(inputs)
	if (locale === "nl") return nl_nav_language_af(inputs)
	if (locale === "da") return da_nav_language_af(inputs)
	if (locale === "nb") return nb_nav_language_af(inputs)
	if (locale === "fi") return fi_nav_language_af(inputs)
	if (locale === "pl") return pl_nav_language_af(inputs)
	if (locale === "ru") return ru_nav_language_af(inputs)
	if (locale === "tr") return tr_nav_language_af(inputs)
	if (locale === "hi") return hi_nav_language_af(inputs)
	if (locale === "id") return id_nav_language_af(inputs)
	if (locale === "ms") return ms_nav_language_af(inputs)
	if (locale === "cs") return cs_nav_language_af(inputs)
	if (locale === "el") return el_nav_language_af(inputs)
	if (locale === "he") return he_nav_language_af(inputs)
	if (locale === "af") return af_nav_language_af(inputs)
	if (locale === "hu") return hu_nav_language_af(inputs)
	return en_nav_language_af(inputs)
});